import { ScreenshotValidationOptions, WopeeOptions } from '../../domain/configuration/config.interface';
import cloneDeep from 'lodash/cloneDeep.js';
import merge from 'lodash/merge.js';

const DEFAULT_SCREENSHOT_VALIDATION_OPTIONS: Partial<ScreenshotValidationOptions> = {
  screenshotValidationEnabled: true,
};

function setScreenshotValidationOptionsDefaults(options?: ScreenshotValidationOptions): ScreenshotValidationOptions {
  return merge(cloneDeep(DEFAULT_SCREENSHOT_VALIDATION_OPTIONS), options);
}

export function setWopeeOptionsDefaults(options?: WopeeOptions): WopeeOptions {
  const screenshotValidationOptions = setScreenshotValidationOptionsDefaults(options?.screenshotValidation);
  return { screenshotValidation: screenshotValidationOptions };
}
